// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableList_root__2VstF"};